<template>
  <div>
    <panel
      v-if="!selectedTemplateEvent && (!typeParam || typeParam === 's')"
      no-button="true"
      title="Use Bonacube template"
    >
      <b-form-select
        @change="selectTemplate"
        :options="templateOptions"
        :disabled="loading"
        :value="null"
      />
      <div v-if="!loading && selectedTemplate" class="mt-2">
        <b-form-group label="Name for the new event">
          <b-form-input
            v-model="sourceData.event.name"
            :disabled="loading || currentTab > 0"
            :state="!duplicateEventName"
          ></b-form-input>
        </b-form-group>
      </div>
    </panel>

    <panel
      v-if="!selectedTemplate && (!typeParam || typeParam === 'e')"
      no-button="true"
      title="Use existing event as template"
    >
      Structure from selected event will be copied to a new event.
      <b-form-select
        @change="selectTemplateEvent"
        :options="eventOptions"
        :disabled="loading || currentTab > 0"
        :value="null"
      />
      <div v-if="!loading && selectedTemplateEvent" class="mt-2">
        <b-form-group label="Name for the new event">
          <b-form-input
            v-model="sourceData.event.name"
            :disabled="loading || currentTab > 0"
            :state="!duplicateEventName"
          ></b-form-input>
        </b-form-group>
      </div>
    </panel>

    <panel
      no-button="true"
      :title="sourceData.event ? sourceData.event.name : '-'"
      v-if="selectedTemplate || selectedTemplateEvent"
    >
      <div v-if="createMessages">
        <div
          v-if="
            createMessages.categories && createMessages.categories.length > 0
          "
        >
          <h6>Following errors occured when trying to create categories:</h6>
          <b-list-group>
            <b-list-group-item
              variant="danger"
              v-for="(error, errorKey) in createMessages.categories"
              :key="errorKey"
            >
              {{ error }}
            </b-list-group-item>
          </b-list-group>
        </div>

        <div
          v-if="
            createMessages.storyboards && createMessages.storyboards.length > 0
          "
        >
          <h6>Following errors occured when trying to create storyboards:</h6>
          <b-list-group>
            <b-list-group-item
              variant="danger"
              v-for="(error, errorKey) in createMessages.storyboards"
              :key="errorKey"
            >
              {{ error }}
            </b-list-group-item>
          </b-list-group>
        </div>

        <div v-if="createMessages.success">
          <h6>Event created:</h6>
          <b-list-group>
            <b-list-group-item variant="success">
              {{ createMessages.success }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div v-if="loading">Loading template data...</div>

      <div v-else>
        <!-- Steps here -->
        <b-container>
          <form-wizard
            @on-complete="submit"
            @on-change="setCurrentTab"
            title="Event wizard"
            subtitle="Do the nasty"
            finishButtonText="Generate Event"
            color="#000"
            stepSize="xs"
          >
            <tab-content
              title="4S / main categories / sub categories / items"
              v-if="tabOneSelectionTree"
              :before-change="validateTab"
            >
              <div class="my-4">
                Select main categories, sub-categories and items you want to
                duplicate to your "Event bank" from each 4S elements of space,
                stuff, staff and service.
              </div>
              <div
                v-for="(mainCategories, typeKey) in tabOneSelectionTree.types"
                :key="typeKey"
              >
                <b-row class="text-left my-3">
                  <b-col cols="12" sm="3">
                    <div class="d-flex">
                      <b-form-checkbox
                        @change="(action) => selectAllFromType(action, typeKey)"
                      />
                      <h5>{{ typeKey }}</h5>
                    </div>
                  </b-col>
                  <b-col>
                    <span
                      v-for="(counter, counterIndex) in [
                        {
                          text: 'Main categories',
                          key: 'main'
                        },
                        {
                          text: 'Sub categories',
                          key: 'sub'
                        },
                        {
                          text: 'Items',
                          key: 'items'
                        }
                      ]"
                      :key="counterIndex"
                    >
                      {{ counter.text }}
                      {{ counters.tabOne[typeKey][counter.key].selected }}
                      /
                      {{ counters.tabOne[typeKey][counter.key].total }}
                    </span>
                  </b-col>
                  <b-col cols="1">
                    <b-button
                      v-b-toggle="`fours-collapse-${typeKey}`"
                      variant="light"
                    >
                      <b-icon-chevron-down class="when-closed" />
                      <b-icon-chevron-up class="when-open" />
                    </b-button>
                  </b-col>
                </b-row>

                <b-collapse :id="`fours-collapse-${typeKey}`" class="mt-2">
                  <div
                    v-for="mainCategory in mainCategories"
                    :key="mainCategory.id"
                    class="my-2"
                  >
                    <b-form-checkbox
                      v-model="mainCategory.selectedForTemplating"
                      :key="mainCategory.id + '-main-check'"
                      @change="
                        (val) => selectAllFromCategory(val, mainCategory)
                      "
                    >
                      <span class="font-weight-bold">
                        {{ mainCategory.name }}
                      </span>
                    </b-form-checkbox>

                    <div
                      v-for="subCategory in mainCategory.children"
                      :key="subCategory.id + '-sub-container'"
                      class="d-flex align-items-center"
                    >
                      <b-form-checkbox
                        v-model="subCategory.selectedForTemplating"
                        :key="subCategory.id + '-sub-check'"
                        class="ml-3 my-2"
                        @change="
                          (val) =>
                            selectAllFromCategory(
                              val,
                              mainCategory,
                              subCategory
                            )
                        "
                        :disabled="!mainCategory.selectedForTemplating"
                      >
                        {{ subCategory.name }}
                      </b-form-checkbox>
                      <span v-if="subCategory.items.length > 0">
                        <b-button
                          @click="showItemSelectionModal(subCategory)"
                          variant="link"
                          :disabled="!subCategory.selectedForTemplating"
                        >
                          Items
                          {{
                            subCategory.items.filter(
                              (i) => i.selectedForTemplating
                            ).length
                          }}
                          /
                          {{ subCategory.items.length }}
                        </b-button>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="
                      !staticTemplateSelected &&
                      tabOneSelectionTree.orphanItems[typeKey].length > 0
                    "
                  >
                    <b-form-checkbox
                      @change="
                        (action) => selectAllOrphanItems(action, typeKey)
                      "
                    >
                      Uncategorized {{ typeKey }} items
                    </b-form-checkbox>
                    <div
                      v-for="orphanItem in tabOneSelectionTree.orphanItems[
                        typeKey
                      ]"
                      :key="orphanItem.id + '-orphan-item-container'"
                      class="d-flex align-items-center"
                    >
                      <b-form-checkbox
                        v-model="orphanItem.selectedForTemplating"
                        :key="orphanItem.id + '-orphan-item-check'"
                        class="mx-4"
                      >
                        {{ orphanItem.name }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </tab-content>

            <tab-content
              title="Storyboards / stages / steps"
              v-if="tabTwoSelectionTree"
            >
              <div class="my-4">
                Select storyboard, stage and step items you want to duplicate to
                your "Storyboard".
              </div>
              <div
                v-for="(
                  storyboard, storyboardKey
                ) in tabTwoSelectionTree.storyboards"
                :key="storyboard.id + '-storyboard-iter'"
              >
                <b-row class="text-left my-3">
                  <b-col cols="12" sm="3">
                    <div class="d-flex">
                      <b-form-checkbox
                        v-model="storyboard.selectedForTemplating"
                        :key="storyboard.id + '-storyboard-check'"
                        @change="
                          (action) =>
                            selectAllFromStoryboard(action, storyboard)
                        "
                      />
                      <h5>{{ storyboard.name }}</h5>
                    </div>
                  </b-col>
                  <b-col>
                    <span
                      v-for="(counter, counterIndex) in [
                        {
                          text: 'Stages',
                          key: 'stages'
                        },
                        {
                          text: 'Steps',
                          key: 'steps'
                        }
                      ]"
                      :key="counterIndex"
                    >
                      {{ counter.text }}
                      {{
                        counters.tabTwo[storyboard.name][counter.key].selected
                      }}
                      /
                      {{ counters.tabTwo[storyboard.name][counter.key].total }}
                    </span>
                  </b-col>
                  <b-col cols="1">
                    <b-button
                      v-b-toggle="`storyboards-collapse-${storyboardKey}`"
                      variant="light"
                    >
                      <b-icon-chevron-down class="when-closed" />
                      <b-icon-chevron-up class="when-open" />
                    </b-button>
                  </b-col>
                </b-row>

                <b-collapse
                  :id="`storyboards-collapse-${storyboardKey}`"
                  class="mt-2"
                >
                  <div
                    v-for="(stage, stageKey) in storyboard.stages"
                    :key="stage.id + '-' + stageKey"
                    class="my-2"
                  >
                    <b-form-checkbox
                      v-model="stage.selectedForTemplating"
                      :key="stage.id + '-stage-check'"
                      @change="
                        (action) =>
                          selectAllFromStage(action, storyboard, stage)
                      "
                      :disabled="!storyboard.hasSelectedScriptItems"
                    >
                      <span class="font-weight-bold">
                        Stage: {{ stage.name }}
                      </span>
                    </b-form-checkbox>

                    <div
                      v-for="(step, stepKey) in stage.steps"
                      :key="stepKey + '-step-container'"
                      class="d-flex align-items-center"
                    >
                      <b-form-checkbox
                        v-model="step.selectedForTemplating"
                        :key="stepKey + '-step-check'"
                        class="ml-3 my-2"
                        @change="
                          (val) =>
                            selectScriptItemsFromStep(
                              val,
                              storyboardKey,
                              stageKey,
                              stepKey
                            )
                        "
                        :disabled="!stage.selectedForTemplating"
                      >
                        Step: {{ step.name }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div>
                <b-row class="text-left my-3">
                  <b-col>
                    <div class="d-flex">
                      <b-form-checkbox
                        @change="
                          (action) => selectAllFromUncategorizedStages(action)
                        "
                      />
                      <h5>Uncategorized stages</h5>
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <b-button
                      v-b-toggle="'uncategorized-stages-collapse'"
                      variant="light"
                    >
                      <b-icon-chevron-down class="when-closed" />
                      <b-icon-chevron-up class="when-open" />
                    </b-button>
                  </b-col>
                </b-row>
                <b-collapse id="uncategorized-stages-collapse" class="mt-2">
                  <div
                    v-for="stage in tabTwoSelectionTree.stages"
                    :key="stage.id + '-stage-iter'"
                  >
                    <b-form-checkbox
                      v-model="stage.selectedForTemplating"
                      :key="stage.id + '-stage-check'"
                    >
                      {{ stage.name }}
                    </b-form-checkbox>

                    <div
                      v-for="(step, stepKey) in stage.steps"
                      :key="stepKey + '-step-container'"
                      class="d-flex align-items-center"
                    >
                      <b-form-checkbox
                        v-model="step.selectedForTemplating"
                        :key="stepKey + '-step-check'"
                        class="mx-4"
                      >
                        {{ step.name }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div>
                <b-row class="text-left my-3">
                  <b-col>
                    <div class="d-flex">
                      <b-form-checkbox
                        @change="
                          (action) => selectAllFromUncategorizedSteps(action)
                        "
                      />
                      <h5>Uncategorized steps</h5>
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <b-button
                      v-b-toggle="'uncategorized-steps-collapse'"
                      variant="light"
                    >
                      <b-icon-chevron-down class="when-closed" />
                      <b-icon-chevron-up class="when-open" />
                    </b-button>
                  </b-col>
                </b-row>
                <b-collapse id="uncategorized-steps-collapse" class="mt-2">
                  <div
                    v-for="(step, stepKey) in tabTwoSelectionTree.steps"
                    :key="stepKey + '-step-iter'"
                  >
                    <b-form-checkbox
                      v-model="step.selectedForTemplating"
                      :key="stepKey + '-step-check'"
                    >
                      {{ step.name }}
                    </b-form-checkbox>
                  </div>
                </b-collapse>
              </div>
            </tab-content>

            <tab-content
              title="Script items"
              v-if="tabThreeSelectionTree && !selectedTemplate"
            >
              <div class="my-4">
                Select scripts and script details you want to duplicate to your
                "Script".
              </div>

              <div
                v-for="(storyboard, storyboardKey) in tabThreeSelectionTree"
                :key="storyboard.id + '-storyboard-iter'"
              >
                <b-row
                  v-if="storyboardHasScriptItems(storyboard)"
                  class="text-left my-3"
                >
                  <b-col cols="11">
                    <div class="d-flex">
                      <b-form-checkbox
                        :key="storyboard.id + '-storyboard-check'"
                        v-model="storyboard.hasSelectedScriptItems"
                        @change="
                          (val) =>
                            selectScriptItemsFromStoryboard(val, storyboardKey)
                        "
                      />
                      <h5>{{ storyboard.name }}</h5>
                    </div>
                  </b-col>
                  <b-col cols="1">
                    <b-button
                      v-b-toggle="`storyboards-collapse-${storyboardKey}`"
                      variant="light"
                    >
                      <b-icon-chevron-down class="when-closed" />
                      <b-icon-chevron-up class="when-open" />
                    </b-button>
                  </b-col>
                </b-row>

                <b-collapse
                  :id="`storyboards-collapse-${storyboardKey}`"
                  class="mt-2"
                >
                  <div
                    v-for="(stage, stageKey) in storyboard.stages"
                    :key="stage.id + '-' + stageKey"
                    class="my-2"
                  >
                    <b-form-checkbox
                      :key="stage.id + '-stage-check'"
                      @change="
                        (val) =>
                          selectScriptItemsFromStoryboard(
                            val,
                            storyboardKey,
                            stageKey
                          )
                      "
                      v-model="stage.hasSelectedScriptItems"
                    >
                      <span class="font-weight-bold">
                        Stage: {{ stage.name }}
                      </span>
                    </b-form-checkbox>

                    <div
                      v-for="(step, stepKey) in stage.steps"
                      :key="stepKey + '-step-container'"
                      class="d-flex align-items-center"
                    >
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          :key="stepKey + '-step-check'"
                          class="mx-4"
                          @change="
                            (val) =>
                              selectScriptItemsFromStoryboard(
                                val,
                                storyboardKey,
                                stageKey,
                                stepKey
                              )
                          "
                          v-model="step.hasSelectedScriptItems"
                        >
                          Step: {{ step.name }}
                        </b-form-checkbox>
                        <b-button
                          @click="
                            showScriptItemSelectionModal(
                              storyboardKey,
                              stageKey,
                              stepKey,
                              step
                            )
                          "
                          variant="link"
                        >
                          Script items
                          {{
                            step.scriptItems.filter(
                              (i) => i.selectedForTemplating
                            ).length
                          }}
                          /
                          {{ step.scriptItems.length }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </tab-content>
          </form-wizard>
        </b-container>
        <!-- /Steps here -->
      </div>
    </panel>

    <b-modal
      id="item-selection-modal"
      :title="
        selectedModalCategory && selectedModalCategory.items.length > 0
          ? 'Select items'
          : 'No items in this category'
      "
      hide-header-close
      ok-only
    >
      <div v-if="selectedModalCategory && selectedModalCategory.items">
        <b-form-checkbox
          @change="
            (val) =>
              selectAllFromCategory(val, null, null, selectedModalCategory)
          "
          :checked="
            selectedModalCategory.items.find((i) => !i.selectedForTemplating)
              ? false
              : true
          "
        >
          Select all from {{ selectedModalCategory.name }}
        </b-form-checkbox>
        <b-form-checkbox
          v-for="(item, itemKey) in selectedModalCategory.items"
          v-model="item.selectedForTemplating"
          :key="itemKey"
          class="mx-4"
        >
          {{ item.name }}
        </b-form-checkbox>
      </div>
    </b-modal>

    <b-modal
      id="script-item-selection-modal"
      :title="
        selectedModalStep.step && selectedModalStep.step.scriptItems.length > 0
          ? 'Select script items'
          : 'No script items in this category'
      "
      hide-header-close
      ok-only
    >
      <div v-if="selectedModalStep.step && selectedModalStep.step.scriptItems">
        <b-form-checkbox
          @change="
            (val) =>
              selectScriptItemsFromStep(
                val,
                selectedModalStep.storyboardKey,
                selectedModalStep.stageKey,
                selectedModalStep.stepKey
              )
          "
          :checked="
            selectedModalStep.step.scriptItems.find(
              (i) => !i.selectedForTemplating
            )
              ? false
              : true
          "
        >
          Select all from {{ selectedModalStep.step.name }}
        </b-form-checkbox>
        <b-form-checkbox
          v-for="(scriptItem, scriptItemKey) in selectedModalStep.step
            .scriptItems"
          v-model="scriptItem.selectedForTemplating"
          :key="scriptItemKey"
          class="mx-4"
          @change="
            (val) =>
              selectScriptItemParents(
                val,
                selectedModalStep.storyboardKey,
                selectedModalStep.stageKey,
                selectedModalStep.stepKey
              )
          "
        >
          <span v-if="scriptItem.item">
            {{ fourSTypes.find((i) => i.id === scriptItem.item.type).name }}:
            {{ scriptItem.item.name }}
            ({{ scriptItem.item.amount }})
          </span>
          <span v-else> Something wrong with the script item... </span>
        </b-form-checkbox>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { BIconChevronDown, BIconChevronUp } from 'bootstrap-vue'
import { mapActions } from 'vuex'
export default {
  components: {
    BIconChevronDown,
    BIconChevronUp,
    FormWizard,
    TabContent
  },
  data: () => ({
    selectedTemplate: null,
    selectedTemplateEvent: null,
    sourceData: {
      event: {},
      categories: [],
      storyboards: [],
      stages: [],
      steps: [],
      items: []
    },
    selectedModalCategory: null,
    selectedModalStep: {
      step: null,
      storyboardKey: null,
      stageKey: null,
      stepKey: null
    },
    typeParam: null,
    loading: null,
    createMessages: null,
    currentTab: null
  }),
  computed: {
    allowSubmit() {
      const { event, categories, storyboards, stages, steps, items } =
        this.selectedForExport
      const eventNameNotEmpty = event.name && event.name.length > 0
      const eventValidish = eventNameNotEmpty && !this.duplicateEventName
      const categoriesSelected = categories.length > 0
      const storyboardsSelected = storyboards.length > 0
      const unCategorizedStagesSelected = stages.length > 0
      const unCategorizedStepsSelected = steps.length > 0
      const unCategorizedItemsSelected = items.length > 0
      return (
        eventValidish &&
        (categoriesSelected ||
          storyboardsSelected ||
          unCategorizedStagesSelected ||
          unCategorizedStepsSelected ||
          unCategorizedItemsSelected)
      )
    },
    duplicateEventName() {
      return Boolean(
        this.eventOptions.find(
          (option) => option.text.trim() === this.sourceData.event.name.trim()
        )
      )
    },
    eventOptions() {
      const events =
        JSON.parse(JSON.stringify(this.$store.state.event.events)) || []
      const options = [
        {
          text: 'Choose existing event',
          value: null
        }
      ]
      events.forEach((item) => {
        options.push({
          value: item,
          text: item.name
        })
      })
      return options
    },
    templateOptions() {
      const eventTemplates =
        JSON.parse(JSON.stringify(this.$store.state.event.eventTemplates)) || []
      const options = [
        {
          text: 'Choose template',
          value: null
        }
      ]
      eventTemplates.forEach((template) => {
        options.push({
          text: template.name,
          value: template
        })
      })
      return options
    },
    tabOneSelectionTree() {
      const mainCategories = this.mainCategories(this.sourceData.categories)
      const groupedMainCategories = {}
      const orphanItemsGroupedByType = {}
      mainCategories.forEach((mainCategory) => {
        const fourSKey = mainCategory.type
          ? mainCategory.type.name
          : 'uncategorized'
        if (!groupedMainCategories[fourSKey]) {
          groupedMainCategories[fourSKey] = []
        }
        groupedMainCategories[fourSKey].push(mainCategory)

        if (!this.staticTemplateSelected) {
          if (!orphanItemsGroupedByType[fourSKey]) {
            orphanItemsGroupedByType[fourSKey] = this.sourceData.items.filter(
              (item) => item.type.name === fourSKey
            )
          }
        }
      })
      return {
        types: groupedMainCategories,
        orphanItems: orphanItemsGroupedByType
      }
    },
    tabTwoSelectionTree() {
      return {
        stages: this.sourceData.stages,
        steps: this.sourceData.steps,
        storyboards: this.sourceData.storyboards
      }
    },
    tabThreeSelectionTree() {
      const storyboards = JSON.parse(
        JSON.stringify(this.tabTwoSelectionTree.storyboards)
      )
      const storyboardsWithFilteredStages = storyboards.map((storyboard) => {
        storyboard.hasSelectedScriptItems = false
        storyboard.stages = storyboard.stages.filter((stage) => {
          return stage.steps.find((step) => {
            return step.scriptItems && step.scriptItems.length > 0
          })
        })
        storyboard.stages = storyboard.stages.map((stage) => {
          stage.steps = stage.steps.filter((step) => {
            return step.scriptItems && step.scriptItems.length > 0
          })
          stage.hasSelectedScriptItems = false
          stage.steps = stage.steps.map((step) => {
            step.hasSelectedScriptItems = Boolean(
              step.scriptItems.find(
                (scriptItem) => scriptItem.selectedForTemplating
              )
            )
            if (step.hasSelectedScriptItems) {
              stage.hasSelectedScriptItems = true
            }
            return step
          })
          if (stage.hasSelectedScriptItems) {
            storyboard.hasSelectedScriptItems = true
          }
          return stage
        })
        return storyboard
      })
      return storyboardsWithFilteredStages
    },
    counters() {
      const count = {
        tabOne: {},
        tabTwo: {}
      }

      // Counters for tab #1
      const types = this.$store.state.type.types
      types.forEach((type) => {
        const key = type.name
        if (!count.tabOne[key]) {
          count.tabOne[key] = {}
        }
        const categories = this.sourceData.categories
        count.tabOne[key].main = {}
        count.tabOne[key].main.total = categories.filter(
          (category) =>
            !category.parent &&
            (category.type.id === type.id || category.type === type.id)
        ).length
        count.tabOne[key].main.selected = categories.filter(
          (category) =>
            !category.parent &&
            category.selectedForTemplating &&
            (category.type.id === type.id || category.type === type.id)
        ).length

        const subCategories = categories.map((item) => item.children).flat()
        count.tabOne[key].sub = {}
        count.tabOne[key].sub.total = subCategories.filter(
          (category) =>
            category.parent &&
            ((category.type && category.type.id === type.id) ||
              category.type === type.id)
        ).length
        count.tabOne[key].sub.selected = subCategories.filter(
          (category) =>
            category.parent &&
            category.selectedForTemplating &&
            ((category.type && category.type.id === type.id) ||
              category.type === type.id)
        ).length

        const items = subCategories.map((category) => category.items).flat()
        count.tabOne[key].items = {}
        count.tabOne[key].items.total = items.filter((item) => {
          if (!item) return false
          return item.type.id === type.id || item.type === type.id
        }).length

        count.tabOne[key].items.selected = items.filter((item) => {
          if (!item) return false
          return (
            item.selectedForTemplating &&
            (item.type.id === type.id || item.type === type.id)
          )
        }).length
      })

      // Counters for tab #2
      const storyboards = this.sourceData.storyboards
      storyboards.forEach((storyboard) => {
        const key = storyboard.name
        if (!count.tabTwo[key]) {
          count.tabTwo[key] = {}
        }
        count.tabTwo[key].stages = {
          selected: storyboard.stages.filter(
            (stage) => stage.selectedForTemplating
          ).length,
          total: storyboard.stages.length
        }

        const steps = storyboard.stages.map((stage) => stage.steps).flat()
        count.tabTwo[key].steps = {
          selected: steps.filter((step) => step && step.selectedForTemplating)
            .length,
          total: steps.length
        }

        const scriptItems = steps
          .filter((step) => step && step.scriptItems)
          .map((step) => step.scriptItems)
          .flat()
        count.tabTwo[key].scriptItems = {
          selected: 0,
          total: 0
        }
        if (scriptItems) {
          count.tabTwo[key].scriptItems = {
            selected: scriptItems.filter(
              (scriptItem) => scriptItem.selectedForTemplating
            ).length,
            total: scriptItems.length
          }
        }
      })
      return count
    },
    fourSTypes() {
      return [...this.$store.state.type.types]
    },
    selectedForExport() {
      const event = {
        name: this.sourceData.event.name,
        description: this.sourceData.event.description,
        image: this.sourceData.event.image
      }

      // Full category tree
      const categories = this.sourceData.categories
        .filter((mainCategory) => mainCategory.selectedForTemplating)
        .map((mainCategory) => {
          let subCategories = mainCategory.children
            .filter((subCategory) => subCategory.selectedForTemplating)
            .map((subCategory) => {
              return {
                name: subCategory.name,
                description: subCategory.description,
                type:
                  typeof subCategory.type === 'object'
                    ? subCategory.type.id
                    : subCategory.type,
                image: subCategory.image,
                items: subCategory.items
              }
            })
          subCategories.forEach((subCategory) => {
            subCategory.items = subCategory.items.filter((item) => {
              return item.selectedForTemplating
            })
            subCategory.items = subCategory.items.map((item) => {
              return {
                name: item.name,
                description: item.description,
                type: typeof item.type === 'object' ? item.type.id : item.type,
                image: item.image,
                category: item.category ? item.category.id : null
              }
            })
            return subCategory
          })
          return {
            name: mainCategory.name,
            description: mainCategory.description,
            type:
              typeof mainCategory.type === 'object'
                ? mainCategory.type.id
                : mainCategory.type,
            image: mainCategory.image,
            children: subCategories
          }
        })

      // Full storyboard tree
      const storyboards = this.sourceData.storyboards
        .filter((storyboard) => storyboard.selectedForTemplating)
        .map((storyboard) => {
          let stages = storyboard.stages
            .filter((stage) => stage.selectedForTemplating)

            .map((stage) => {
              return {
                name: stage.name,
                description: stage.description,
                insights: stage.insights,
                target: stage.target,
                responsiblePerson: stage.responsiblePerson,
                budget: stage.budget,
                steps: stage.steps,
                image: stage.image
              }
            })

          stages.forEach((stage) => {
            stage.steps = stage.steps.filter(
              (subItem) => subItem.selectedForTemplating
            )

            stage.steps = stage.steps.map((step) => {
              let scriptItems = step.scriptItems.filter(
                (scriptItem) => scriptItem.selectedForTemplating
              )

              return {
                name: step.name,
                description: step.description,
                insights: step.insights,
                target: step.target,
                plan: step.plan,
                responsiblePerson: step.responsiblePerson,
                budget: step.budget,
                image: step.image,
                scriptItems: scriptItems
              }
            })
            return stage
          })

          return {
            name: storyboard.name,
            description: storyboard.description,
            insights: storyboard.insights,
            target: storyboard.target,
            responsiblePerson: storyboard.responsiblePerson,
            budget: storyboard.budget,
            image: storyboard.image,
            stages: stages
          }
        })

      let stages = []
      let steps = []
      let items = []

      if (!this.staticTemplateSelected) {
        // Orphan stages (no storyboard)
        stages = this.sourceData.stages
          .filter((stage) => stage.selectedForTemplating)
          .map((stage) => {
            return {
              name: stage.name,
              description: stage.description,
              insights: stage.insights,
              target: stage.target,
              responsiblePerson: stage.responsiblePerson,
              budget: stage.budget,
              steps: stage.steps,
              image: stage.image
            }
          })

        // Orphan steps (no stage)
        steps = this.sourceData.steps
          .filter((step) => step.selectedForTemplating)
          .map((step) => {
            return {
              name: step.name,
              description: step.description,
              insights: step.insights,
              target: step.target,
              plan: step.plan,
              responsiblePerson: step.responsiblePerson,
              budget: step.budget,
              image: step.image
            }
          })

        // Orpan items (no category)
        items = this.sourceData.items
          .filter((item) => item.selectedForTemplating)
          .map((item) => {
            return {
              name: item.name,
              description: item.description,
              type: item.type.id,
              image: item.image,
              category: null
            }
          })
      }

      return {
        event: event,
        categories: categories,
        stages: stages,
        steps: steps,
        storyboards: storyboards,
        items: items,
        isStatic: this.staticTemplateSelected
      }
    },
    staticTemplateSelected() {
      return Boolean(this.selectedTemplate && !this.selectedTemplateEvent)
    }
  },
  methods: {
    ...mapActions('category', ['getCategoriesTemplate']),
    ...mapActions('item', ['getItemsTemplate']),
    ...mapActions('storyboard', ['getStoryboardsTemplate']),
    ...mapActions('stage', ['getStagesTemplate']),
    ...mapActions('step', ['getStepsTemplate']),
    ...mapActions('event', [
      'createEventFromTemplate',
      'getEvent',
      'getEvents',
      'getEventTemplates'
    ]),
    ...mapActions('type', ['getTypes']),
    async selectTemplateEvent(event) {
      this.loading = true
      this.selectedTemplateEvent = event

      if (!event) {
        return
      }

      const sourceData = {
        event: event
      }
      sourceData.categories = await this.getCategoriesTemplate(event.id)
      sourceData.items = await this.getItemsTemplate(event.id)
      sourceData.storyboards = await this.getStoryboardsTemplate(event.id)
      sourceData.stages = await this.getStagesTemplate(event.id)
      sourceData.steps = await this.getStepsTemplate(event.id)

      this.sourceData = sourceData
      this.loading = false
    },

    selectTemplate(template) {
      this.selectedTemplate = template
      let sourceData = {
        event: {},
        categories: [],
        storyboards: []
      }

      if (template) {
        sourceData = template
      }

      this.sourceData = sourceData
    },

    mainCategories(categories) {
      if (Array.isArray(categories)) {
        return categories.filter((item) => !item.parent)
      }
      return []
    },
    subCategories(categories, mainCategory) {
      if (Array.isArray(categories)) {
        return categories.filter(
          (item) => item.parent && item.parent.id === mainCategory.id
        )
      }
      return []
    },

    async submit() {
      this.loading = true
      const result = await this.createEventFromTemplate(this.selectedForExport)
      this.loading = false

      if (result.errors) {
        this.createMessages = result.errors
      } else {
        this.createMessages = {
          success: `Event "${result.created.value.event.name}" created with success. Redirecting to dashboard ...`
        }
        setTimeout(() => {
          this.$router.push('/dashboard')
        }, 3000)
      }
    },

    showItemSelectionModal(category) {
      this.selectedModalCategory = category
      this.$bvModal.show('item-selection-modal')
    },

    showScriptItemSelectionModal(storyboardKey, stageKey, stepKey, step) {
      this.selectedModalStep = {
        storyboardKey: storyboardKey,
        stageKey: stageKey,
        stepKey: stepKey,
        step: step
      }
      this.$bvModal.show('script-item-selection-modal')
    },

    selectAllFromType(action, typeName) {
      const type = this.$store.state.type.types.find(
        (type) => type.name === typeName
      )
      const sourceData = this.sourceData
      sourceData.categories = sourceData.categories.map((category) => {
        const typeMatch =
          category.type === type.id || category.type.id === type.id
        if (typeMatch) {
          category.selectedForTemplating = action

          category.children = category.children.map((subCategory) => {
            const subCategoryTypeMatch =
              subCategory.type &&
              (subCategory.type === type.id || subCategory.type.id === type.id)
            if (subCategoryTypeMatch) {
              subCategory.selectedForTemplating = action
              subCategory.items = subCategory.items.map((subCategoryItem) => {
                const itemTypeMatch =
                  subCategoryItem.type === type.id ||
                  subCategoryItem.type.id === type.id
                if (itemTypeMatch) {
                  subCategoryItem.selectedForTemplating = action
                }
                return subCategoryItem
              })
            }
            return subCategory
          })
        }
        return category
      })
      this.sourceData = sourceData
    },

    selectAllFromStoryboard(action, selectedStoryboard) {
      const sourceData = this.sourceData
      const storyboardIndex = this.sourceData.storyboards.findIndex(
        (storyboard) => storyboard.id === selectedStoryboard.id
      )
      const storyboard = sourceData.storyboards[storyboardIndex]
      storyboard.selectedForTemplating = action
      storyboard.hasSelectedScriptItems = action
      storyboard.stages = storyboard.stages.map((stage) => {
        stage.selectedForTemplating = action
        stage.steps = stage.steps.map((step) => {
          step.selectedForTemplating = action
          step.scriptItems = step.scriptItems.map((scriptItem) => {
            scriptItem.selectedForTemplating = action
            return scriptItem
          })
          return step
        })
        return stage
      })
      sourceData.storyboards[storyboardIndex] = storyboard
      this.sourceData = sourceData
    },
    selectAllFromCategory(
      isSelected,
      topLevelCategory,
      childCategory,
      modalCategory
    ) {
      const sourceData = this.sourceData
      if (!modalCategory) {
        const mainCategoryIndex = this.sourceData.categories.findIndex(
          (category) => category.id === topLevelCategory.id
        )
        const mainCategory = sourceData.categories[mainCategoryIndex]
        if (!childCategory) {
          // Handle subcategories and items of main category
          mainCategory.children = mainCategory.children.map((subCategory) => {
            subCategory.selectedForTemplating = isSelected
            subCategory.items = subCategory.items.map((item) => {
              item.selectedForTemplating = isSelected
              return item
            })
            return subCategory
          })
        } else {
          // Handle items of sub category
          const subCategoryIndex = mainCategory.children.findIndex(
            (category) => category.id === childCategory.id
          )
          const subCategory = mainCategory.children[subCategoryIndex]
          subCategory.items = subCategory.items.map((item) => {
            item.selectedForTemplating = isSelected
            return item
          })
          mainCategory.children[subCategoryIndex] = subCategory
        }
        sourceData.categories[mainCategoryIndex] = mainCategory
      } else {
        const mainCategoryIndex = this.sourceData.categories.findIndex(
          (category) =>
            category.children.find(
              (childCategory) => childCategory.id === modalCategory.id
            )
              ? true
              : false
        )
        const mainCategory = sourceData.categories[mainCategoryIndex]
        // Handle items of sub category
        const subCategoryIndex = mainCategory.children.findIndex(
          (category) => category.id === modalCategory.id
        )
        const subCategory = mainCategory.children[subCategoryIndex]
        subCategory.items = subCategory.items.map((item) => {
          item.selectedForTemplating = isSelected
          return item
        })
        mainCategory.children[subCategoryIndex] = subCategory
        sourceData.categories[mainCategoryIndex] = mainCategory
      }
      this.sourceData = sourceData
    },
    selectAllFromStage(isSelected, selectedStoryboard, selectedStage) {
      const sourceData = this.sourceData
      const storyboardIndex = sourceData.storyboards.findIndex(
        (storyboard) => storyboard.id === selectedStoryboard.id
      )
      const storyboard = sourceData.storyboards[storyboardIndex]
      const stageIndex = storyboard.stages.findIndex(
        (stage) => stage.id === selectedStage.id
      )
      const stage = storyboard.stages[stageIndex]
      stage.steps = stage.steps.map((step) => {
        step.selectedForTemplating = isSelected

        step.scriptItems = step.scriptItems.map((scriptItem) => {
          scriptItem.selectedForTemplating = isSelected
          return scriptItem
        })

        return step
      })
      storyboard.stages[stageIndex] = stage
      sourceData.storyboards[storyboardIndex] = storyboard

      this.sourceData = sourceData
    },
    selectScriptItemsFromStep(
      isSelected,
      storyboardIndex,
      stageIndex,
      stepIndex
    ) {
      const sourceData = this.sourceData
      const storyboard = sourceData.storyboards[storyboardIndex]
      const stage = storyboard.stages[stageIndex]
      const step = stage.steps[stepIndex]

      step.scriptItems = step.scriptItems.map((scriptItem) => {
        scriptItem.selectedForTemplating = isSelected
        return scriptItem
      })

      stage.steps[stepIndex] = step
      storyboard.stages[stageIndex] = stage
      sourceData.storyboards[storyboardIndex] = storyboard

      this.sourceData = sourceData
    },
    selectAllFromUncategorizedStages(isSelected) {
      const sourceData = this.sourceData
      sourceData.stages = sourceData.stages.map((stage) => {
        stage.selectedForTemplating = isSelected
        stage.steps = stage.steps.map((step) => {
          step.selectedForTemplating = isSelected
          return step
        })
        return stage
      })
      this.sourceData = sourceData
    },
    selectAllFromUncategorizedSteps(isSelected) {
      const sourceData = this.sourceData
      sourceData.steps = sourceData.steps.map((step) => {
        step.selectedForTemplating = isSelected
        return step
      })
      this.sourceData = sourceData
    },
    selectAllOrphanItems(isSelected, typeKey) {
      const sourceData = this.sourceData
      sourceData.items = sourceData.items.map((item) => {
        const typeMatch = item.type && item.type.name == typeKey
        if (typeMatch) {
          item.selectedForTemplating = isSelected
        }
        return item
      })
      this.sourceData = sourceData
    },
    selectScriptItemParents(isSelected, storyboardKey, stageKey, stepKey) {
      if (isSelected) {
        const sourceData = this.sourceData
        sourceData.storyboards[storyboardKey].selectedForTemplating = isSelected
        sourceData.storyboards[storyboardKey].hasSelectedScriptItems =
          isSelected

        if (stageKey) {
          sourceData.storyboards[storyboardKey].stages[
            stageKey
          ].selectedForTemplating = isSelected
          sourceData.storyboards[storyboardKey].stages[
            stageKey
          ].hasSelectedScriptItems = isSelected

          if (stepKey) {
            sourceData.storyboards[storyboardKey].stages[stageKey].steps[
              stepKey
            ].selectedForTemplating = isSelected
            sourceData.storyboards[storyboardKey].stages[stageKey].steps[
              stepKey
            ].hasSelectedScriptItems = isSelected
            this.sourceData = sourceData
          } else {
            sourceData.storyboards[storyboardKey].stages[stageKey].steps =
              sourceData.storyboards[storyboardKey].stages[stageKey].steps.map(
                (step) => {
                  step.selectedForTemplating = isSelected
                  step.hasSelectedScriptItems = isSelected
                  return step
                }
              )
          }
        } else {
          sourceData.storyboards[storyboardKey].stages = sourceData.storyboards[
            storyboardKey
          ].stages.map((stage) => {
            stage.selectedForTemplating = isSelected
            stage.hasSelectedScriptItems = isSelected
            return stage
          })
        }
      }
    },
    selectScriptItemsFromStoryboard(
      isSelectAction,
      storyboardKey,
      stageKey,
      stepKey
    ) {
      const sourceData = this.sourceData
      const fromAllStages =
        Number.isInteger(storyboardKey) &&
        stageKey === undefined &&
        stepKey === undefined
      const fromAllStepsInStage =
        Number.isInteger(storyboardKey) &&
        Number.isInteger(stageKey) &&
        stepKey === undefined
      const fromStepInStage =
        Number.isInteger(storyboardKey) &&
        Number.isInteger(stageKey) &&
        Number.isInteger(stepKey)

      if (isSelectAction) {
        /**
         * Something was selected
         */
        if (fromAllStages) {
          /**
           * Storyboard selected
           * - traverse selections to stages and steps
           */
          // sourceData.storyboards[storyboardKey].hasSelectedScriptItems = true
          // sourceData.storyboards[storyboardKey].selectedForTemplating = true
          sourceData.storyboards[storyboardKey].stages.forEach((stage) => {
            // stage.hasSelectedScriptItems = true
            // stage.selectedForTemplating = true
            stage.steps.forEach((step) => {
              // step.hasSelectedScriptItems = true
              // step.selectedForTemplating = true
              step.scriptItems.forEach((scriptItem) => {
                scriptItem.selectedForTemplating = true
                this.selectScriptItemParents(
                  true,
                  storyboardKey,
                  stageKey,
                  stepKey
                )
              })
            })
          })
        }
        if (fromAllStepsInStage) {
          /**
           * Stage selected
           * - traverse selections to steps
           */
          /*
          sourceData.storyboards[storyboardKey].stages[
            stageKey
          ].hasSelectedScriptItems = true
          sourceData.storyboards[storyboardKey].stages[
            stageKey
          ].selectedForTemplating = true
          */
          sourceData.storyboards[storyboardKey].stages[stageKey].steps.forEach(
            (step) => {
              step.hasSelectedScriptItems = true
              step.scriptItems.forEach((scriptItem) => {
                scriptItem.selectedForTemplating = true
                this.selectScriptItemParents(
                  true,
                  storyboardKey,
                  stageKey,
                  stepKey
                )
              })
            }
          )
        }
        /**
         * Step selected
         * - traverse selections to script items
         */
        if (fromStepInStage) {
          /*
          sourceData.storyboards[storyboardKey].stages[stageKey].steps[
            stepKey
          ].hasSelectedScriptItems = true
          sourceData.storyboards[storyboardKey].stages[stageKey].steps[
            stepKey
          ].selectedForTemplating = true
          */
          sourceData.storyboards[storyboardKey].stages[stageKey].steps[
            stepKey
          ].scriptItems.forEach((scriptItem) => {
            scriptItem.selectedForTemplating = true
            this.selectScriptItemParents(true, storyboardKey, stageKey, stepKey)
          })
        }
      } else {
        /**
         * Some selection was cleared
         */
        if (fromAllStages) {
          /**
           * Storyboard cleared
           * - traverse clearings down the tree
           */
          sourceData.storyboards[storyboardKey].hasSelectedScriptItems = false
          sourceData.storyboards[storyboardKey].stages.forEach((stage) => {
            stage.hasSelectedScriptItems = false
            stage.steps.forEach((step) => {
              step.hasSelectedScriptItems = false
              step.scriptItems.forEach((scriptItem) => {
                scriptItem.selectedForTemplating = false
              })
            })
          })
        }
        if (fromAllStepsInStage) {
          /**
           * Stage cleared
           * - traverse clearings down the tree
           * - evaluate storyboard selection based on other stage-and-below selections
           */
          sourceData.storyboards[storyboardKey].stages[stageKey].steps.forEach(
            (step) => {
              step.hasSelectedScriptItems = false
              step.scriptItems.forEach((scriptItem) => {
                scriptItem.selectedForTemplating = false
              })
            }
          )
        }
        if (fromStepInStage) {
          /**
           * Step cleared
           * - traverse clearings down the tree
           * - clear stage selection if no other step-and-below selections
           */
          sourceData.storyboards[storyboardKey].stages[stageKey].steps[
            stepKey
          ].hasSelectedScriptItems = false
          sourceData.storyboards[storyboardKey].stages[stageKey].steps[
            stepKey
          ].scriptItems.forEach((scriptItem) => {
            scriptItem.selectedForTemplating = false
          })
          const scriptItemsSelected = Boolean(
            sourceData.storyboards[storyboardKey].stages[stageKey].steps.find(
              (step) => {
                return step.scriptItems.find(
                  (scriptItem) => scriptItem.selectedForTemplating
                )
              }
            )
          )
          sourceData.storyboards[storyboardKey].stages[
            stageKey
          ].hasSelectedScriptItems = scriptItemsSelected
        }
      }

      this.sourceData = Object.assign({}, sourceData, {})
    },
    storyboardHasScriptItems(storyboard) {
      const hasScriptItems = storyboard.stages.find((stage) => {
        return stage.steps.find((step) => {
          return step.scriptItems && step.scriptItems.length > 0
        })
          ? true
          : false
      })
      return Boolean(hasScriptItems)
    },
    validateTab() {
      return !this.duplicateEventName
    },
    setCurrentTab(prev, curr) {
      this.currentTab = curr
    }
  },
  async mounted() {
    this.typeParam = this.$route.query.t
    if (!this.typeParam || this.typeParam === 'e') {
      await this.getEvents()
    }
    if (!this.typeParam || this.typeParam === 's') {
      await this.getEventTemplates()
    }
    await this.getTypes()
    this.$root.$on('bv::modal::hide', () => {
      this.sourceData = Object.assign({}, this.sourceData, {})
    })
  }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
